/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, string, bool,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import ReactHtmlParser from 'react-html-parser';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import GraphqlFoodDetailsUI from '../GraphqlFoodDetailsUI/GraphqlFoodDetailsUI';
import { clubComponentType } from '../common/types';

const styles = (theme) => ({
    contents: {
        textTransform: 'uppercase',
    },
    block: {
        display: 'block',
        width: '95%',
        margin: '0 auto',
    },
    notEligible: {
        color: theme.palette.productTitleColor || '#2f2f2f',
        fontSize: '0.9em',
    },
    serviceLink: {
        '& a': {
            color: theme.palette.productTitleColor || '#2f2f2f',
        },
        fontSize: '14px',
    },
});

const GraphqlClubDescription = ({
    longDescription,
    classes,
    clubComponents,
    shortDescription,
    productName,
    isPassportEligible,
}) => {
    const seed = useUIDSeed();
    const productContents = [...(clubComponents || []).map((component) => (`${component.month || ''}: ${component.name || ''} ${component.productContents}` || ''))];
    return (
        <>
            <DesktopMobile
                breakpoint={960}
                desktop={() => (
                    <div data-testid="club-description-desktop" className={classes.classes}>
                        <p className={classes.contents}>Product Description</p>
                        <ReactMarkdown
                            source={shortDescription}
                            escapeHtml={false}
                        />
                        <ReactMarkdown
                            source={longDescription}
                            escapeHtml={false}
                        />

                        <p>{ReactHtmlParser(productName)}</p>

                        {(clubComponents || []).map((component) => (
                            <p key={seed(component)}>
                                <span>{ReactHtmlParser(component.month) || ''}: {ReactHtmlParser(component.name) || ''}</span>
                                <ReactMarkdown
                                    source={component.productContents || ''}
                                    escapeHtml={false}
                                />
                            </p>
                        ))}
                    </div>
                )}
                mobile={() => (
                    <div data-testid="club-description-mobile" className={classes.block}>
                        <div>
                            <GraphqlFoodDetailsUI
                                clubDescription
                                shortDescription={shortDescription}
                                longDescription={longDescription}
                                productContents={productContents}
                            />
                        </div>
                        <div>
                            {!isPassportEligible && (
                                <p className={classes.notEligible}>
                                    <strong>Please Note:</strong> This club is not eligible for CELEBRATIONS PASSPORT&#174;
                                </p>
                            )}
                        </div>
                        <div>
                            <p className={classes.serviceLink}><Link to="/h/view/custserv-handling">Shipping and Processing Details</Link></p>
                        </div>
                    </div>
                )}
            />
        </>
    );
};

GraphqlClubDescription.propTypes = {
    classes: object.isRequired,
    longDescription: string.isRequired,
    clubComponents: clubComponentType.isRequired,
    shortDescription: string.isRequired,
    productName: string.isRequired,
    isPassportEligible: bool.isRequired,
};

export default (withStyles(styles)(GraphqlClubDescription));
